module.exports = __webpack_public_path__ + "images/emoji/rewind.e8092e2fde8a2140efba.png";